var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBusinessContract = function SvgBusinessContract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.333 17.5V26l4.5-1 3.5 3 1.5-.5 3.5-3 8 1.5v-8.5l-6-2-5.5 1-2-.5-7.5 1.5Z",
    fill: "#FFE1CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.458 1.875H4.708a3.5 3.5 0 0 0-3.5 3.5v21a1.75 1.75 0 0 0 1.75 1.75h1.675M4.708 6.25h7.875M4.708 9.75h7.875M4.708 13.25h3.92",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.833 12.375V4.5a2.633 2.633 0 0 1 2.625-2.625A2.632 2.632 0 0 1 23.083 4.5v1.75h-5.25M25.708 23.878l-5.584 1.118",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m20.678 18.661-2.637 1.113a1.658 1.658 0 0 1-1.309-.017 1.731 1.731 0 0 1-.911-.97 1.78 1.78 0 0 1 .824-2.216l2.635-1.317a2.302 2.302 0 0 1 1.86-.11l5.412 2.133",
    fill: "#FFE1CF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m20.678 18.661-2.637 1.113a1.658 1.658 0 0 1-1.309-.017 1.731 1.731 0 0 1-.911-.97 1.78 1.78 0 0 1 .824-2.216l2.635-1.317a2.302 2.302 0 0 1 1.86-.11l5.412 2.133",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 25.04h1.867l3.557 2.714a.968.968 0 0 0 1.342.105l4.97-4.104a.982.982 0 0 0 .15-1.358l-2.738-3.044",
    fill: "#FFE1CF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 25.04h1.867l3.557 2.714a.968.968 0 0 0 1.342.105l4.97-4.104a.982.982 0 0 0 .15-1.358l-2.738-3.044",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m16.359 16.757-.288-.233a2.088 2.088 0 0 0-2.013-.257l-4.165 1.766",
    fill: "#FFE1CF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m16.359 16.757-.288-.233a2.088 2.088 0 0 0-2.013-.257l-4.165 1.766",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.208 25.916h.35a1.331 1.331 0 0 0 1.4-1.25v-6.251a1.331 1.331 0 0 0-1.4-1.25h-.35",
    fill: "#FFE1CF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.208 25.916h.35a1.331 1.331 0 0 0 1.4-1.25v-6.251a1.331 1.331 0 0 0-1.4-1.25h-.35",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.458 25.916h-.35a1.331 1.331 0 0 1-1.4-1.25v-6.251a1.33 1.33 0 0 1 1.4-1.25h.35",
    fill: "#FFE1CF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.458 25.916h-.35a1.331 1.331 0 0 1-1.4-1.25v-6.251a1.33 1.33 0 0 1 1.4-1.25h.35",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgBusinessContract;